import {
    IHaveTPMEventStandardCalculatorBaseMetricsUpdateOptions,
    IHaveTPMEventStandardCalculatorProductsSynchronizeOptions, IHaveTPMEventStandardCalculatorRefreshOptions,
    IHaveTPMEventStandardCalculatorSpendSynchronizeOptions,
    ITPMEventChangedEvent,
    ITPMEventProductChangedEvent,
    ITPMEventProductGroupChangedEvent,
    ITPMEventStandardCalculator,
    ITPMEventStandardCalculatorClientExtension
} from "../PA.TPM.Core/PA.TPM.IF.TPM.Event.Aspects";
import {IMessageProvider, IProgressProvider, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {TPMEventBO} from "../PA.TPM.BusinessObjects/TPMEventBO";
import {EventStandardCalculatorExtDefault} from "./client/EventStandardCalculatorExtDefault";
import {TPMEventStandardCalculatorExtProvider} from "./client/EventStandardCalculatorExtProvider";
import {Subscription} from "rxjs";
import {ASync} from "../PA.Core/Basic/ASync";
import * as _ from 'lodash'
import {PlanningService} from "./PlanningService"
import {WB_TPM_EventProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {IPlanningServiceSummaryDataResults} from "./PA.TPM.Services.IF";
import {TPMEventSpend} from "../PA.TPM.BusinessObjects/TPMEventBO.ITPMEventSpend";
import {ITPMEventSpend} from "../PA.TPM.Core/PA.TPM.IF.TPM.EventSpend.Aspects";


export class TPMEventStandardCalculator
    implements ITPMEventStandardCalculator {

    private _calcMessageProvider: MessageProvider;
    private _calcProgressProvider: ProgressProvider;
    private _tpmEventBO: TPMEventBO

    private _StandardExtension: ITPMEventStandardCalculatorClientExtension = EventStandardCalculatorExtDefault
    private _ClientExtension: ITPMEventStandardCalculatorClientExtension = {id: "client"}
    private _bIsLoaded: boolean

    private _tpmEventPropertyChangeSubscription: Subscription
    private _tpmEventProductGroupPropertyChangeSubscription: Subscription
    private _tpmEventProductPropertyChangeSubscription: Subscription

    constructor() {
        this._calcMessageProvider = new MessageProvider()
        this._calcProgressProvider = new ProgressProvider()
        this._tpmEventBO = undefined
        this._bIsLoaded = false

        this._tpmEventPropertyChangeSubscription = undefined
        this._tpmEventProductGroupPropertyChangeSubscription = undefined
        this._tpmEventProductPropertyChangeSubscription = undefined

    }

    Register(tpmEventBO: TPMEventBO): void {
        const self = this
        const bo = tpmEventBO
        // Currently, we don't listen to anything,.. just on demand calc.

        this.UnRegister()
        this._tpmEventBO = tpmEventBO

        if (bo) {
            bo.OnLoadComplete
                .then((results) => {
                    return TPMEventStandardCalculatorExtProvider.getTPMEventStandardCalculatorExtension(bo.WB_TPMEvent.WB_EventTypeRow.cif.STANDARDCALCULATORCLASS)
                })
                .then((result) => {
                    if (!_.isEmpty(result)) {
                        self._ClientExtension = result
                    } else {
                        self._ClientExtension = {id: "none"}
                    }
                    return ASync.resolve()
                })
                .then((ignore) => {
                    this._tpmEventPropertyChangeSubscription = bo.TPMEventPropertyChanged.subscribe(this._OnTPMEventPropertyChanged.bind(self))
                    this._tpmEventProductGroupPropertyChangeSubscription = bo.TPMEventProductGroupPropertyChanged.subscribe(this._OnEventProductGroupPropertyChanged.bind(self))
                    this._tpmEventProductPropertyChangeSubscription = bo.TPMEventProductPropertyChanged.subscribe(this._OnEventProductPropertyChanged.bind(self))

                    // Subscribe

                    self._bIsLoaded = true
                })
                .catch((err) => {
                    console.log("Error in TPM Event Standard Calculator Register(): ", err)
                    self._bIsLoaded = false
                })
        }
    }

    UnRegister(): void {
        this._tpmEventBO = undefined
        this._bIsLoaded = false

        if (this._tpmEventPropertyChangeSubscription) {
            this._tpmEventPropertyChangeSubscription.unsubscribe()
            this._tpmEventPropertyChangeSubscription = undefined
        }

        if (this._tpmEventProductGroupPropertyChangeSubscription) {
            this._tpmEventProductGroupPropertyChangeSubscription.unsubscribe()
            this._tpmEventProductGroupPropertyChangeSubscription = undefined
        }

        if (this._tpmEventProductPropertyChangeSubscription) {
            this._tpmEventProductPropertyChangeSubscription.unsubscribe()
            this._tpmEventProductPropertyChangeSubscription = undefined
        }

    }

    private get bIsLoaded(): boolean {
        return this._bIsLoaded
    }


    get CalcProgressProvider(): IProgressProvider {
        return this._calcProgressProvider
    }

    get CalcMessageProvider(): IMessageProvider {
        return this._calcMessageProvider
    }

    Refresh(pOpts?: IHaveTPMEventStandardCalculatorRefreshOptions): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.BaseMetrics_update(pOpts)
                .then((ignore) => {
                    return self.Products_synchronize(pOpts)
                })
                .then((ignore) => {
                    return self.Spend_synchronize(pOpts)
                })
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    async BaseMetrics_update(pOpts?: IHaveTPMEventStandardCalculatorBaseMetricsUpdateOptions): Promise<void> {
        const self = this

        let opts: IHaveTPMEventStandardCalculatorBaseMetricsUpdateOptions = {}
        let bo: TPMEventBO = undefined
        let arrEvtPGs: WB_TPM_EventProductGroupRow[] = []
        self.CalcMessageProvider.clearMessages()

        let functionContext: any = {}

        _.defaults(opts, pOpts,
            self._ClientExtension.BaseMetricsUpdateOptionsDefault,
            self._StandardExtension.BaseMetricsUpdateOptionsDefault)

        if (_.isEmpty(self._tpmEventBO))
            return

        bo = self._tpmEventBO
        try {
            // Determine Product Groups
            if (_.isEmpty(opts.WB_TPM_EventProductGroupRows)) {
                arrEvtPGs = bo.WB_TPMEvent.WB_TPM_EventProductGroupRows
            } else {
                arrEvtPGs = opts.WB_TPM_EventProductGroupRows
            }
            arrEvtPGs = _.filter(arrEvtPGs, (aRow) => aRow.isActive)

            if (_.isEmpty(arrEvtPGs))
                return

            let arrPGIds = _.map(arrEvtPGs, (aRow) => aRow.cif.WB_PRDGRP_ID)

            let aPlanningService = new PlanningService()

            self.CalcProgressProvider.start("Refreshing Base Metrics")
            let summaryData = await aPlanningService.getSummaryData({
                inStoreStartDt: DateUtils.convertToSAPBW(bo.WB_TPMEvent.InStoreStartDt),
                inStoreEndDt: DateUtils.convertToSAPBW(bo.WB_TPMEvent.InStoreEndDt),
                shipmentStartDt: DateUtils.convertToSAPBW(bo.WB_TPMEvent.ShipmentStartDt),
                shipmentEndDt: DateUtils.convertToSAPBW(bo.WB_TPMEvent.ShipmentEndDt),
                WB_PLAN_ID: bo.WB_TPMEvent.cif.WB_PLAN_ID,
                WB_PRDGRP_IDS: arrPGIds
            })

            if (!summaryData.bSuccess) {
                self._calcMessageProvider.addTextMessages('BaseMtrcE', MessageType.Error, summaryData.sErrors)
                self._calcMessageProvider.addTextMessages('BaseMtrcW', MessageType.Warning, summaryData.sWarnings)
                self.CalcProgressProvider.exception('Base Metrics Request Failed')
                return
            }

            _.forEach(arrEvtPGs, (aRow) => {
                if (!(aRow.cif.WB_PRDGRP_ID in summaryData))
                    return

                let pgResults = summaryData[aRow.cif.WB_PRDGRP_ID]
                if (opts.bIncludeVolume) {
                    aRow.cif.CNS_PLAN_BASE_QTY = _.round(_.toNumber(pgResults.PLN_CNS_BASE_QTY || 0), 6)
                    aRow.cif.CNS_PLAN_EDLP_QTY = _.round(_.toNumber(pgResults.PLN_CNS_EDLP_QTY || 0), 6)
                    aRow.cif.SHIP_PLAN_BASE_QTY = _.round(_.toNumber(pgResults.PLN_SHIP_BASE_QTY || 0), 6)
                    aRow.cif.SHIP_PLAN_EDLP_QTY = _.round(_.toNumber(pgResults.PLN_SHIP_EDLP_QTY || 0), 6)
                    aRow.cif.SHIP_PLAN_ADJ_QTY = _.round(_.toNumber(pgResults.PLN_SHIP_ADJ || 0), 6)
                    aRow.cif.SHIP_PLAN_DISPLAY_QTY = _.round(_.toNumber(pgResults.PLN_SHIP_DISP_QTY || 0), 6)
                }

                if (opts.bIncludePricing) {
                    aRow.cif.GROSS_LIST_PRICE = _.round(_.toNumber(pgResults.AVG_GROSSLIST || 0), 6)
                    aRow.cif.NET_LIST_PRICE = _.round(_.toNumber(pgResults.AVG_NETLIST || 0), 6)
                    aRow.cif.BASE_PRICE = _.round(_.toNumber(pgResults.AVG_BASE_PRICE || 0), 6)

                    if (bo.WB_TPMEvent.WB_EventTypeRow.cif.PGEDLPPRICE_POLICY === 'EDLPEvent') {
                        aRow.cif.EDLP_PRICE = _.round(_.toNumber(pgResults.AVG_EDLP_PRICE || 0), 6)
                    }

                }

            })

            if (opts.bRunRowCalc) {

                await self._handleExtensionExecution('ProductGroup_RowCalcContext', [bo, functionContext])

                for (var i = 0; i < arrEvtPGs.length; i++) {
                    let aEvtPGRow = arrEvtPGs[i]
                    await self._handleExtensionExecution('ProductGroup_RowCalc', [bo, aEvtPGRow, functionContext])
                }

            }

            await self.Price_Event_Products()

            //pricing lookups for products.. make a new function, async function
            self.CalcProgressProvider.finish()
        } catch(err)  {
            self.CalcProgressProvider.exception(err)
            throw (err)
        }

    }

    async Price_Event_Products(): Promise<void> {
        const self = this

        try {

            if (_.isEmpty(self._tpmEventBO))
                return

            let bo = self._tpmEventBO
            self.CalcProgressProvider.start('Price Event Products')
            await self._handleExtensionExecution('Price_Event_Products', [bo])

            self.CalcProgressProvider.finish()

        } catch (err) {
            self.CalcProgressProvider.exception(err)
            throw err
        }

    }

    Products_synchronize(pOpts?: IHaveTPMEventStandardCalculatorProductsSynchronizeOptions): Promise<void> {
        const self = this
        const functionContext = {}

        let opts: IHaveTPMEventStandardCalculatorProductsSynchronizeOptions = {}
        let bo: TPMEventBO = undefined
        self.CalcMessageProvider.clearMessages()

        _.defaults(opts,
            pOpts,
            self._ClientExtension.ProductsSynchronizeOptionsDefault,
            self._StandardExtension.ProductsSynchronizeOptionsDefault)

        return new Promise<void>((resolve, error) => {
            if (_.isEmpty(self._tpmEventBO)) {
                resolve()
                return
            }
            bo = self._tpmEventBO
            self.CalcProgressProvider.start("Sync Products")
            self._handleExtensionExecution("SynchronizeEventProducts", [bo, functionContext, opts])
                .then((results) => {
                    self.CalcProgressProvider.finish()
                    resolve()
                })
                .catch((err) => {
                    self.CalcProgressProvider.exception(err)
                    error(err)
                })
        })

    }

    Spend_synchronize(pOpts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions): Promise<void> {
        const self = this
        const functionContext = {}
        let arrSpends: ITPMEventSpend[] = []

        let opts: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions = {}
        let bo: TPMEventBO = undefined
        self.CalcMessageProvider.clearMessages()


        _.defaults(opts,
            pOpts,
            self._ClientExtension.SpendSynchronizeOptionsDefault,
            self._StandardExtension.SpendSynchronizeOptionsDefault)

        return new Promise<void>((resolve, error) => {
            if (_.isEmpty(self._tpmEventBO)) {
                resolve()
                return
            }
            bo = self._tpmEventBO

            if (_.isEmpty(opts.TPMEventSpends)) {
                arrSpends = bo.TPMEventSpends
            } else {
                arrSpends = opts.TPMEventSpends
            }
            arrSpends = _.filter(arrSpends, (aSpend: ITPMEventSpend) => aSpend.isActive)

            if (_.isEmpty(arrSpends)) {
                resolve()
                return
            }


            async function RunSpendSynchronize() {

                await self._SpendSyncSetupContext(functionContext, opts)

                for (let idx = 0; idx < arrSpends.length; idx++) {
                    let tpmEventSpend = arrSpends[idx]
                    await self._handleExtensionExecution("EventSpendSync", [bo, tpmEventSpend, functionContext, opts])
                }

            }

            //
            self.CalcProgressProvider.start("Sync Event Spend")

            RunSpendSynchronize()
                .then((results) => {
                    self.CalcProgressProvider.finish()
                    resolve()
                })
                .catch((err) => {
                    self.CalcProgressProvider.exception(err)
                    error(err)
                })
        })

    }


    private _SpendSyncSetupContext(context: any, opts?: IHaveTPMEventStandardCalculatorSpendSynchronizeOptions): Promise<void> {
        const self = this
        let bo: TPMEventBO = undefined


        return new Promise<void>((resolve, error) => {

            if (_.isEmpty(self._tpmEventBO)) {
                resolve()
                return
            }
            bo = self._tpmEventBO

            if (context.bContextComplete) {
                resolve()
                return
            }
            let args = [bo, context]
            self._handleExtensionExecution("EventSpendSyncContext", args)
                .then((ignore) => {
                    context.bContextComplete = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

    }

    //


    //<editor-fold desc="Record Change Event Handlers">

    _OnTPMEventPropertyChanged(event: ITPMEventChangedEvent) {
        const self = this

        if (!self.bIsLoaded) {
            return
        }
        if (_.isEmpty(event)) {
            return
        }

        //OnTPMEventPropertyChangeBefore
        self._handleExtensionExecution("OnTPMEventPropertyChange", [event.TPMEventBO, event])
            .then((ignore) => {
                // Success
            })
            .catch((err) => {
                console.log("Standard Calculator TPM Event Property Change error: ", err)
            })


    }

    _OnEventProductGroupPropertyChanged(event: ITPMEventProductGroupChangedEvent) {
        const self = this

        if (!self.bIsLoaded) {
            return
        }
        if (_.isEmpty(event)) {
            return
        }

        //OnTPMEventProductGroupPropertyChange
        self._handleExtensionExecution("OnTPMEventProductGroupPropertyChange", [event.TPMEventBO, event])
            .then((ignore) => {
              //success
            })
            .catch((err) => {
                console.log("Standard Calculator TPM Event Product Group Property Change error: ", err)
            })

    }

    _OnEventProductPropertyChanged(event: ITPMEventProductChangedEvent) {
        const self = this

        if (!self.bIsLoaded) {
            return
        }
        if (_.isEmpty(event)) {
            return
        }

        self._handleExtensionExecution("OnTPMEventProductPropertyChange", [event.TPMEventBO, event])
            .then((ignore) => {
                // Success
            })
            .catch((err) => {
                console.log("Standard Calculator TPM Event Product Property Change error: ", err)
            })

    }


    _handleExtensionExecution(sFunctionName: string, functionArgs: any[]): Promise<void> {
        const self = this

        if (!self.bIsLoaded) {
            return ASync.resolve()
        }

        return new Promise<void>((resolve, error) => {

            let applyArgs = functionArgs || []


            let sBeforeName = sFunctionName + "Before"
            let sAfterName = sFunctionName + "After"

            let beforePromise: Promise<any> = undefined
            //
            switch (true) {
                case _.isFunction(self._ClientExtension[sBeforeName]):
                    beforePromise = self._ClientExtension[sBeforeName].apply(self, applyArgs)
                    break;
                case _.isFunction(self._StandardExtension[sBeforeName]):
                    beforePromise = self._StandardExtension[sBeforeName].apply(self, applyArgs)
                    break;
                default:
                    beforePromise = ASync.resolve(true)
            }

            beforePromise
                .then((res) => {
                    let mainPromise: Promise<any> = undefined
                    switch (true) {
                        case _.isFunction(self._ClientExtension[sFunctionName]):
                            mainPromise = self._ClientExtension[sFunctionName].apply(self, applyArgs)
                            break;
                        case _.isFunction(self._StandardExtension[sFunctionName]):
                            mainPromise = self._StandardExtension[sFunctionName].apply(self, applyArgs)
                            break;
                        default:
                            mainPromise = ASync.resolve(true)
                    }

                    return mainPromise
                })
                .then((res) => {
                    let afterPromise: Promise<any> = undefined
                    switch (true) {
                        case _.isFunction(self._ClientExtension[sAfterName]):
                            afterPromise = self._ClientExtension[sAfterName].apply(self, applyArgs)
                            break;
                        case _.isFunction(self._StandardExtension[sAfterName]):
                            afterPromise = self._StandardExtension[sAfterName].apply(self, applyArgs)
                            break;
                        default:
                            afterPromise = ASync.resolve(true)
                    }
                    return afterPromise
                })
                .then((res) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }


    // Add Event Spend Change
    // Add Event Spend PG Change
    // Add Event Spend Product Change

    //</editor-fold>


}